<script>
export default {
 methods: {
  isActive(path) {
   return this.$route.path === path;
  },
 },
};
</script>

<template>
<div class="col-xl-3 theiaStickySidebar">
<div class="card">
<div class="card-body">
  <div class="d-flex flex-column list-group settings-list">
    
   <router-link to="/app-settings/app-store" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
   <i v-if="isActive('/app-settings/app-store')" class="ti ti-arrow-badge-right me-2"></i> App Store</router-link>
    
  <!-- <router-link to="/app-settings/roles" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
  <i v-if="isActive('/app-settings/roles')" class="ti ti-arrow-badge-right me-2"></i>
  Roles & Permissions</router-link> -->

  </div>
</div>
</div>
</div>
</template>
